if (!customElements.get('valenora-personalisierung')) {
  customElements.define('valenora-personalisierung', class extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.formId);
      this.root = this.closest('product-info');
      if (!this.form || !this.root) return;
      this.variants = JSON.parse(this.querySelector('[data-valenora-variants]').textContent);
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.root.addEventListener('change', (event) => {
        const picker = event.target.closest('variant-selects');
        if (!picker || event.target.tagName !== 'SELECT') return;
        this.filterExecutions(picker);
      }, { ...options, capture: true });
      this.filterExecutions(this.root.querySelector('variant-selects'));
      this.onChange = (event) => {
        if (event.target.matches('input[name="id"]') && event.target.form === this.form) this.sync();
        if (event.target.closest('variant-selects')) this.setMode('');
      };
      this.root.addEventListener('change', this.onChange, options);
      this.form.addEventListener('submit', (event) => {
        this.sync();
        const id = this.form.querySelector('[name="id"]').value;
        if (!this.variants.some((variant) => String(variant.id) === id)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const name = this.querySelector('[name="properties[Name]"]');
        const date = this.querySelector('[name="properties[Datum]"]');
        const text = this.querySelector('[name="properties[Wunschtext]"]');
        name.setCustomValidity('');
        text.setCustomValidity('');
        if (!name.disabled && !name.value.trim() && !date.value) name.setCustomValidity(this.dataset.pairError);
        if (!text.disabled && !text.value.trim()) text.setCustomValidity(this.dataset.textError);
        if (!this.form.reportValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { ...options, capture: true });
      this.addEventListener('input', () => {
        this.querySelectorAll('input, textarea').forEach((field) => field.setCustomValidity(''));
      }, options);
      this.form.addEventListener('formdata', (event) => {
        this.querySelectorAll('[name^="properties["]').forEach((field) => {
          if (field.disabled || !field.value.trim()) event.formData.delete(field.name);
        });
      }, options);
      this.sync();
    }
    filterExecutions(picker) {
      if (!picker) return;
      const selects = picker.querySelectorAll('select');
      if (selects.length !== 2) return;
      const motif = selects[0].value;
      const executions = new Set(this.variants.filter((variant) => variant.options[0] === motif).map((variant) => variant.options[1]));
      Array.from(selects[1].options).forEach((option) => {
        option.hidden = !executions.has(option.value);
        option.disabled = option.hidden;
      });
      if (!executions.has(selects[1].value)) {
        const first = Array.from(selects[1].options).find((option) => !option.hidden);
        if (first) {
          selects[1].value = first.value;
          Array.from(selects[1].options).forEach((option) => option.toggleAttribute('selected', option === first));
        }
      }
    }
    disconnectedCallback() { this.controller?.abort(); }
    setMode(mode) {
      this.querySelectorAll('fieldset[data-mode]').forEach((group) => {
        const active = group.dataset.mode === mode;
        group.hidden = !active;
        group.disabled = !active;
        group.querySelectorAll('input, textarea').forEach((field) => {
          field.disabled = !active;
          field.required = active && group.dataset.mode === 'custom';
          field.setCustomValidity('');
        });
      });
    }
    sync() {
      const id = this.form.querySelector('[name="id"]')?.value;
      const variant = this.variants.find((item) => String(item.id) === id);
      const values = variant?.options || [];
      this.setMode(values.includes('Freier Wunschtext') ? 'custom' : values.includes('Mit Namen/Datum') ? 'personal' : '');
    }
  });
}
